import t from '@rcm/i18n-client';
import React, { ChangeEvent, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFindCurrentDiscountRuleQuery } from '../../api';
import { selectDiscount, setDiscount } from '../../slices/discount';

const DiscountSelector = () => {
    const dispatch = useDispatch();

    const discountRuleQuery = useFindCurrentDiscountRuleQuery();

    const discount = useSelector(selectDiscount);

    const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
        dispatch(setDiscount(e.target.value));
    }, []);

    const handleInputChange = function(e){
        var targetVal = e.target.value.replace(/\D/g, '');
        var inputVal = isNaN(parseInt(targetVal)) ? 0 : parseInt(targetVal);
        var nums = discountRuleQuery?.data?.available;
        var min =  Math.min(...nums);
        var max =  Math.max(...nums);

        if(inputVal >= min && inputVal <= max){
            dispatch(setDiscount(inputVal));
        } else if(inputVal < min){
            dispatch(setDiscount(min));
        } else if(inputVal > max){
            dispatch(setDiscount(max));
        }
    };

    return <Form>
        <Form.Group>
            <input className="form-control" type={"text"} value={discount} onChange={handleInputChange} style={{width: '150px', display: 'inline-block'}} />
            <label style={{marginLeft : '10px'}} >% Discount</label>
            {/*<Form.Select value={discount} onChange={handleChange}>
                {(discountRuleQuery?.data?.available ?? []).map((percent) => (
                    <option value={percent} key={percent}>{t('{percent}% Discount', {percent})}</option>
                ))}
            </Form.Select>*/}
        </Form.Group>
    </Form>;
}

export default DiscountSelector;
